var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgValidationCompleted(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9241 14.3456C28.8824 22.0775 22.5807 28.3799 14.8489 28.4223C7.11699 28.4648 0.882859 22.2313 0.924537 14.4994C0.966214 6.76756 7.26792 0.465205 14.9998 0.422735C22.7317 0.380264 28.9658 6.61376 28.9241 14.3456ZM2.32452 14.4917C2.28701 21.4504 7.89773 27.0606 14.8564 27.0223C21.8151 26.9841 27.4866 21.312 27.5241 14.3533C27.5616 7.39464 21.9509 1.78449 14.9922 1.82271C8.03356 1.86094 2.36203 7.53305 2.32452 14.4917Z",
    fill: "#6B7280"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29 14.4996C29 12.6611 28.6379 10.8406 27.9343 9.14207C27.2307 7.44351 26.1995 5.90016 24.8995 4.60014C23.5995 3.30012 22.0561 2.26889 20.3576 1.56532C18.659 0.861754 16.8385 0.499634 15 0.499634L15 14.4996L29 14.4996Z",
    fill: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidationCompleted);
export default __webpack_public_path__ + "static/media/VALIDATION_COMPLETED.69696245a92b2e8ecfe9f5d26332833d.svg";
export { ForwardRef as ReactComponent };